import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./TechStack.css";

const techCategories = {
  Mobile: [
    { name: "iOS", icon: "/icons/mobile/org/apple.svg" },
    { name: "Android", icon: "/icons/mobile/org/android.svg" },
    { name: "React Native", icon: "/icons/mobile/org/react.svg" },
    { name: "Flutter", icon: "/icons/mobile/org/flutter.svg" },
    { name: "Ionic", icon: "/icons/mobile/org/ionic.svg" },
    { name: "Swift", icon: "/icons/mobile/org/swift.svg" },
  ],
  Frontend: [
    { name: "HTML", icon: "/icons/frontend/org/html.svg" },
    { name: "CSS", icon: "/icons/frontend/org/css.svg" },
    { name: "JavaScript", icon: "/icons/frontend/org/js.svg" },
    { name: "React.js", icon: "/icons/frontend/org/react.svg" },
    { name: "Vue.js", icon: "/icons/frontend/org/vue.svg" },
    { name: "Bootstrap", icon: "/icons/frontend/org/bootstrap.svg" },
    { name: "Angular", icon: "/icons/frontend/org/angular.svg" },
  ],
  Backend: [
    { name: "PHP", icon: "/icons/backend/org/php.svg" },
    { name: "Node.js", icon: "/icons/backend/org/nodejs.svg" },
    { name: "Python", icon: "/icons/backend/org/python.svg" },
    { name: "Java", icon: "/icons/backend/org/java.svg" },
    { name: ".Net", icon: "/icons/backend/org/dotnet.svg" },
  ],
  Database: [
    { name: "MySQL", icon: "/icons/database/org/mysql.svg" },
    { name: "MongoDB", icon: "/icons/database/org/mongodb.svg" },
    { name: "PostgreSQL", icon: "/icons/database/org/postgresql.svg" },
    { name: "Firebase", icon: "/icons/database/org/firebase.svg" },
    { name: "SQLite", icon: "/icons/database/org/sqlite.svg" },
    { name: "Oracle", icon: "/icons/database/org/oracle.svg" },
  ],
  "Infra & DevOps": [
    { name: "AWS", icon: "/icons/infra/org/aws.svg" },
    { name: "Azure", icon: "/icons/infra/org/azure.svg" },
    { name: "Kubernetes", icon: "/icons/infra/org/kubernetes.svg" },
    { name: "Google Cloud", icon: "/icons/infra/org/google-cloud.svg" },
    { name: "Selenium", icon: "/icons/infra/org/selenium.svg" },
  ],
  "UI/UX": [
    { name: "Figma", icon: "/icons/ui/org/figma.svg" },
    { name: "Adobe XD", icon: "/icons/ui/org/adobe-xd.svg" },
    { name: "Sketch", icon: "/icons/ui/org/sketch.svg" },
    { name: "Photoshop", icon: "/icons/ui/org/photoshop.svg" },
  ],
};

const TechStack = () => {
  const [activeTab, setActiveTab] = useState("Mobile");

  return (
    <div className="tech-stack-container">
      <h3 className="sub-title">Technology Stacks</h3>
      <div className="tabs">
        {Object.keys(techCategories).map((tab) => (
          <span
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          className="icon-grid"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
        >
          {techCategories[activeTab].map((tech, index) => (
            <motion.div
              className="tech-item"
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.05 }}
            >
              <img src={tech.icon} alt={tech.name} className="icon-img" />
              <div className="label">{tech.name}</div>
            </motion.div>
          ))}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default TechStack;
